import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import ProjectManagementOnboardingImage from 'assets/images/project-management-onboarding.png'

import i18n from 'modules/core/lib/i18n'

import ActionButton from '../ActionButton'

interface ProjectsLandingDescriptionProps {
  onPrimaryButtonClick: () => void
}

const ProjectsLandingDescription: React.FC<ProjectsLandingDescriptionProps> = ({
  onPrimaryButtonClick,
}) => {
  return (
    <Box paddingX="s64" paddingY="s48" width="full" flexDirection="column" gap="s32">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box gap="s32">
          <Box gap="s12">
            <Box width="fit-content">
              <Tag leftItem="circle" showCircle type={'lime'}>
                {i18n.t('project_management.landing_page.description.status.in_your_plan')}
              </Tag>
            </Box>
            <Box gap="s6" maxWidth="s400">
              <Text.Header1 htmlTag="h1">
                {i18n.t('project_management.landing_page.description.title')}
              </Text.Header1>
              <Text.Normal>
                {i18n.t('project_management.landing_page.description.subtitle')}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="column" gap="s8">
            <Box width="fit-content">
              <ActionButton onPrimaryButtonClick={onPrimaryButtonClick} />
            </Box>
          </Box>
        </Box>
        <Box boxShadow="s100">
          <img src={ProjectManagementOnboardingImage} height="100%" width="100%" />
        </Box>
      </Box>
    </Box>
  )
}

export default ProjectsLandingDescription
